import React from 'react';
import InfoHover from 'modules/common/components/hovers/infoHover';

const AudienceTotalUsersDisclaimer: React.FC<IAudienceTotalUsersDisclaimerProps> = props => {
    const { syncType } = props;

    return (
        <InfoHover>Includes activated accounts added from your Sparrow Directory, {syncType} Groups and pending user invites sent to new employees. Deactivated accounts are not included.</InfoHover>
    );
}

interface IAudienceTotalUsersDisclaimerProps {
    syncType: string;
};

export default AudienceTotalUsersDisclaimer;